// @flow

import React, {Component} from 'react'

import api from '../../../src/api/client'
import css from './MedicineGuide.css'
import MedicineGuideItem from './MedicineGuideItem'

type State = {
  isFetching: boolean,
  show: boolean,
  medicineData: Array<Object>,
  style: Object,
  styleOpacity: Object,
}

type Props = {
  vnr: string,
}
class MedicineGuide extends Component {
  props: Props

  state: State = {
    show: true,
    isFetching: false,
    medicineData: [],
    style: {maxHeight: 0},
    styleOpacity: {maxHeight: 0, opacity: 0},
  }

  componentWillReceiveProps(newProps: Object) {
    if(!newProps.mounted)
      return this.unMountStyle()
    this.setState({show: true})
    setTimeout(this.mountStyle, 5)
  }

  unMountStyle = () => {
    this.setState({
      style: {maxHeight: 0},
      styleOpacity: {maxHeight: 0, opacity: 0},
    })
  }

  mountStyle = () => {
    this.setState({
      style: {maxHeight: '3000px'},
      styleOpacity: {maxHeight: '100px', opacity: 1},
    })
  }

  componentWillMount(){
    this.getMedicineGuideData()
    setTimeout(this.mountStyle, 5)
  }

  transitionEnd = () => {
    if(!this.props.mounted){
      this.setState({show: false})
    }
  }

  getMedicineGuideData = async() => {
    this.setState({isFetching: true})
    try {
      const {medicineData} = this.state
      if(medicineData.length === 0) {
        const {vnr} = this.props
        const response = await api.resources.medicineinfo.getMedicineInfosByVnr(vnr)
        if(Array.isArray(response) && response.length > 0) {
          const medicineData = [
            {
              title: 'Käyttötarkoitus',
              text: response[0].purpose,
            },
            {
              title: 'Annostus',
              text: response[0].dosage,
            },
            {
              title: 'Lääkkeen ottaminen',
              text: response[0].useMethod,
            },
            {
              title: 'Vaikutustapa',
              text: response[0].effect,
            },
            {
              title: 'Haittavaikutukset',
              text: response[0].adverseReaction,
            },
            {
              title: 'Raskaus ja imetys',
              text: response[0].pregnancy,
            },
            {
              title: 'Säilytys',
              text: response[0].stowage,
            },
            {
              title: 'Ulkonäkö',
              text: response[0].appearance,
            },
          ]

          this.setState({medicineData: medicineData})
          this.setState({isFetching: false})
        } else {
          this.setState({medicineData: []})
          this.setState({isFetching: false})
        }
      }
    } catch(e) {
      this.setState({medicineData: []})
      this.setState({isFetching: false})
      console.log(e)
    }
  }

  render() {
    const {vnr} = this.props
    const {styleOpacity, isFetching} = this.state

    if (!this.state.show || !vnr) {
      return null
    }
    const {medicineData} = this.state
    if (isFetching) {
      return (
        <div className={css.component} style={styleOpacity} onTransitionEnd={this.transitionEnd}>
          <div className={css.text}>Ladataan...</div>
        </div>
      )
    }
    if (!isFetching && medicineData.length === 0) {
      return (
        <div className={css.component} style={styleOpacity} onTransitionEnd={this.transitionEnd}>
          <p className={css.text}>Lisätiedot ei ole saatavilla</p>
        </div>)

    } else {
      return (
        <div className={css.component} style={this.state.style} onTransitionEnd={this.transitionEnd}>
          <h4 className={css.title}>Lääkeopas</h4>
          {medicineData.map((medicine, index) => (
            <MedicineGuideItem
              key={index}
              title={medicine.title}
              text={medicine.text}
            />
          ))}
          <p className={css.smallText}>Lääkeoppaan tiedot: &copy; Lääketietokeskus</p>
        </div>
      )
    }
  }
}

export default MedicineGuide



// WEBPACK FOOTER //
// ./src/homepage/components/MedicineGuide.js